import { SliderSection } from './SharedNearbyFilterComponents'
import { NearbyFilterSlider } from './NearbyFilterSlider'
import { size } from '@styles/theme'

const renderValueRangeText = (props) => (
  <>{props[0] + ' - ' + (props[1] === '65' ? `${props[1]}+` : props[1] )}</>
)

const AgeSection = ({ value, onChange, resetValue, isDisplayedInactive }) => {
  const isInactive = isDisplayedInactive || (value?.[0] === 18 && value?.[1] === 65)
  return (
    <SliderSection style={{ paddingBottom: size(1) }}>
      <NearbyFilterSlider
        name='age'
        value={value}
        onValueChange={val => onChange('age', val)}
        step={1}
        min={18}
        max={65}
        title='Age'
        resetValue={resetValue}
        isInactive={isInactive}
        renderValueRangeText={renderValueRangeText}
      />
    </SliderSection>
  )
}

export { AgeSection }
